// PaymentSection.jsx
import React from "react";
import { FormControl, RadioGroup, FormControlLabel, Radio, Button } from "@mui/material";
import { styled } from "@mui/material";
import CustomerPaymentPage from "../customerPaymentPage";
 
const Next = styled((props) => <Button variant="contained" {...props} />)(
  ({ theme }) => ({
    backgroundColor: "rgb(0,105,255)",
    boxShadow: "none",
    borderRadius: "30px",
    maxWidth: "170px",
    marginTop: "40px",
    color: "white",
    alignItems: "center",
    display: "flex",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "rgb(0,90,230)",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[200],
      opacity: 1,
    },
  })
); 


const PaymentSection = ({ selectedOption, onOptionChange, bookingTypedata, hasError, onConfirm , answers, email}) => {
  return (
    <>
      {Number(bookingTypedata?.price) > 0 && (
        <FormControl>
          <RadioGroup value={selectedOption} onChange={onOptionChange}>
            <FormControlLabel value="payNow" control={<Radio />} label="Pay Now" />
            <FormControlLabel value="payLater" control={<Radio />} label="Pay Later" disabled={bookingTypedata.isPaymentRequired} />
          </RadioGroup>
        </FormControl>
      )}
      {Number(bookingTypedata?.price) > 0 ? (
        selectedOption === "payNow" ? (
          // You can integrate your CustomerPaymentPage here.
          // It should call onConfirm when the payment is approved. 
          <CustomerPaymentPage answers ={answers} email ={email} disabled={hasError} bookingTypedata={bookingTypedata} onApprove={(x,y) => onConfirm(x,y)}/>
        ) : (
          <Next disabled={hasError} onClick={() => onConfirm()}>Schedule Booking</Next>
        )
      ) : (
        <Next disabled={hasError} onClick={() => onConfirm()}>Schedule Booking</Next>
      )}
    </>
  );
};

export default PaymentSection;
